import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./css/Menu.css";
import "./css/ViewDashboard.css";
import SideNav from "./SideNav";
import SideNavMob from "./SideNavMob";
import TopRootDiv from "./TopRootDiv";
import SherDineNav from "./SherDineNav";
import COD from "./images/ViewDashboard/Cash on delivery1.png";
import OnlineSales1 from "./images/ViewDashboard/Online sales1.png";
import Sales1 from "./images/ViewDashboard/Sales1.png";
import dinein from "./images/ViewDashboard/dinein.png";
import delivery from "./images/ViewDashboard/delivery.png";
import takeaway from "./images/ViewDashboard/takeaway.png";
import totalsales from "./images/ViewDashboard/totalsales.png";
import filter from "./images/ViewDashboard/filter.png";
import up from "./images/ViewDashboard/up.png";
import downgraph from "./images/ViewDashboard/downgraph.png";
import Shopping from "./images/ViewDashboard/Shopping bag1.png";
import Tag1 from "./images/ViewDashboard/Tag1.png";
import Tax1 from "./images/ViewDashboard/Tax1.png";
import Vector1 from "./images/ViewDashboard/Vector1.png";
import Refresh from "./images/icons/Refresh.png";
import down from "./images/icons/Upload.png";
import SalesGraph from "./sampleGraph";
import NavBarMobile from "./Mobile/NavBar";
import { DBContext } from "./DBContext";
import StatisticsGraph from "./StatisticsGraph";
// import { PieChart } from 'react-minimal-pie-chart';
// import DonutChart from 'react-donut-chart';
import { Doughnut } from "react-chartjs-2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

function ViewDashboard() {
  const location = useLocation();
  // const [Database, setDatabase] = useState(localStorage.getItem('DB'));

  const { logginedDB, sideNavState, sideNavStateFunc } = useContext(DBContext);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  // useEffect(() => {
  //     // Check location state first
  //     if (location.state && location.state.DB) {
  //         setDatabase(location.state.DB);
  //         localStorage.setItem('DB', location.state.DB); // Update localStorage
  //     } else {
  //         // Fallback to localStorage if state is null
  //         const storedDB = localStorage.getItem('DB');
  //         if (storedDB) {
  //             setDatabase(storedDB);
  //         }
  //     }
  // }, [location.state]);

  // //("DB", Database);

  //  const currentOffset = reset ? 0 : offset;
  //          const response = await axios.get(
  //              `${apiBaseUrl}/getSalesDetailsAlls/${logginedDB}`,
  //              {
  //                  // params: {
  //                  //     limit: loadAll ? undefined : limit,
  //                  //     offset: loadAll ? undefined : offset,
  //                  //     todayOnly: !dates.sdate && !dates.edate, // Load today's data if no date filter
  //                  //     all: loadAll
  //                  // }
  //                  // params: { limit, offset, todayOnly: true }
  //                  params: {
  //                      limit: reset ? undefined : limit,
  //                      offset: reset ? 0 : offset,
  //                      todayOnly: !dates.sdate && !dates.edate,
  //                      userType: selectedUserType || uType?.userType // Pass selected user type

  //                  }
  //              }
  //          );

  const [totalSales, setTotalSale] = useState([]);
  const [dineIn, setDineIn] = useState([]);
  const [takeAway, setTakeAway] = useState([]);
  const [deliveryOrders, setDelivery] = useState([]);
  const [salesData, setSalesData] = useState([]);

  const fetchSales = async () => {
    return await axios.get(`${apiBaseUrl}/TotalSalesBill/${logginedDB}`);
  };

  // Example inside useEffect
  useEffect(() => {
    const loadSales = async () => {
      try {
        const response = await fetchSales();
        setTotalSale(response.data);
      } catch (error) {
        console.error("Error fetching sales:", error);
      }
    };

    loadSales();
  }, []);

  useEffect(() => {
    if (totalSales.length > 0) {
      setDineIn(totalSales.filter((a) => a.Type === "Dine In"));
      setTakeAway(totalSales.filter((a) => a.Type === "Take Away"));
      setDelivery(totalSales.filter((a) => a.Type === "Delivery"));
    }
  }, [totalSales]);

  const desktopView = window.innerWidth > 639;


  const [totals, setTotals] = useState({
    total: 0,
    cashTotal: 0,
    cardTotal: 0,
    dueTotal: 0,
    onlineTotal: 0,
    totalBills: 0,
    dineInCount: 0,
    takeAwayCount: 0,
    deliveryCount: 0,
  });

  // date: optional 'YYYY-MM-DD' string; omit for today
  const fetchDashboardTotals = async (date) => {
    if (!logginedDB) return;
    try {
      // If date is passed as an event object (e.g. click event), ignore it
      const dateString = typeof date === 'string' ? date : '';
      const params = dateString ? `?date=${dateString}` : '';
      const response = await axios.get(`${apiBaseUrl}/DashboardTotals/${logginedDB}${params}`);
      if (response.status === 200 && response.data) {
        const d = response.data;
        setTotals({
          total:         parseFloat(d.netTotal)      || 0,
          cashTotal:     parseFloat(d.cashTotal)     || 0,
          cardTotal:     parseFloat(d.cardTotal)     || 0,
          dueTotal:      parseFloat(d.creditTotal)   || 0,
          onlineTotal:   parseFloat(d.onlineTotal)   || 0,
          totalBills:    parseInt(d.totalBills)      || 0,
          dineInCount:   parseInt(d.dineInCount)     || 0,
          takeAwayCount: parseInt(d.takeAwayCount)   || 0,
          deliveryCount: parseInt(d.deliveryCount)   || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard totals:", error);
    }
  };

  useEffect(() => {
    fetchDashboardTotals(); // no arg = today
  }, [logginedDB]);

  const [sideNav, setSideNav] = useState(false);
  const handleSideNav = (state) => {
    setSideNav(state);
  };

  const [falseState, setFalseState] = useState(null);

  const DonutData = {
    labels: ["Vegetable", "Gas", "Electricity", "Rent"],
    datasets: [
      {
        label: "# of votes",
        data: [12, 13, 14, 15],
        backgroundColor: ["#3070F5", "#57BEB5", "#AE59DC", "#5B61D6"],
        borderColor: "#FFF",
        borderWidth: 1,
        borderAlign: "inner",
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 12, // Size of the legend box
          padding: 20, // Space between the box and the label
          font: {
            size: 12, // Set the font size
          },
        },
      },
    },
    layout: {
      padding: {
        bottom: 0, // Adjust space for the legend
        top: 20,
      },
    },
    beforeUpdate: function (chart) {
      // Ensure the chart and its datasets are available
      if (
        chart &&
        chart.data &&
        chart.data.datasets &&
        chart.data.datasets[0]
      ) {
        const originalLabels =
          chart.legend.options.labels.generateLabels(chart);
        originalLabels.forEach((label, index) => {
          // Customize legend box color based on the dataset's backgroundColor
          label.fillStyle =
            chart.data.datasets[0].backgroundColor[index] || "#ccc"; // Use custom color
          label.lineWidth = 2;
          label.strokeStyle = "#000";
          label.cornerRadius = 20;
        });
      }
    },
    cutout: "70%", // Adjust the inner hole size
    rotation: Math.PI / 4,
  };

  // Calculate percentage for cashTotal, cardTotal, and overall total
  const cashPercentage = (totals.cashTotal / totals.total) * 100;
  const cardPercentage = (totals.cardTotal / totals.total) * 100;
  const duePercentage = (totals.dueTotal / totals.total) * 100;
  const otherPercentage = (totals.otherTotal / totals.total) * 100;
  const onlinePayPercentage = (totals.onlinePayTotal / totals.total) * 100;
  const onlineCODPercentage = (totals.onlineCODTotal / totals.total) * 100;

  // Function to format the date as '2 Jan 25'
  const formatDate = (date) => {
    // Ensure the input is a Date object
    const validDate = new Date(date);

    if (isNaN(validDate)) {
      console.error("Invalid date passed to formatDate:", date);
      return "";
    }

    const day = validDate.getDate().toString().padStart(2, "0");
    const month = validDate.toLocaleString("default", { month: "short" });
    const year = validDate.getFullYear().toString().slice(-2);

    return `${day} ${month} ${year}`;
  };

  const [selectedDateSales, setSelectedDateSales] = useState(null);
  const [selectedDateExpense, setSelectedDateExpense] = useState(null);
  const [formattedDateSales, setFormattedDateSales] = useState(() =>
    formatDate(new Date())
  );
  const [formattedDateExpense, setFormattedDateExpense] = useState(() =>
    formatDate(new Date())
  );

  const dateInputSalesRef = useRef(null);
  const dateInputExpenseRef = useRef(null);

  //   const handleGetSales = async (date) => {
  //     try {
  //         const response = await axios.get(`${apiBaseUrl}/getSalesDetails/${logginedDB}/${date}`)
  //         if (response.status == 200) {
  //             const data = response.data
  //             setSalesData(data);
  //         }
  //     } catch (error) {

  //     }
  //   }

  //   useEffect(() => {
  //     handleGetSales(formatDate(new Date()))
  //   },[])

  // Format for month instead of full date
  const formatMonth = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
    return `${year}-${month}`;
  };


  const formatYear = (date) => {
  return date.getFullYear().toString(); // "2025"
};

  const handleGetSales = async (date) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/TotalSalesBillByMonth/${logginedDB}`,
        { date } // 👈 body
      );
      if (response.status === 200) {
        setSalesData(response.data);
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };

  useEffect(() => {
    // handleGetSales(formatMonth(new Date())); // "YYYY-MM"
      handleGetSales(formatYear(new Date())); // sends "2025"

  }, []);

  // Handle date selection — refreshes both the bar chart AND the payment totals panel
  const handleDateChangeSales = (event) => {
    const rawDate = event.target.value; // 'YYYY-MM-DD' from the input
    if (rawDate) {
      const formattedDate = formatDate(rawDate);
      setSelectedDateSales(rawDate);
      setFormattedDateSales(formattedDate);
      handleGetSales(rawDate);          // bar chart
      fetchDashboardTotals(rawDate);    // payment totals & summary
    }
  };

  const handleDateChangeExpense = (event) => {
    const selectedDate = event.target.value; // Get the date value from the input
    if (selectedDate) {
      const formattedDate = formatDate(selectedDate);
      setSelectedDateExpense(formattedDate);
      setFormattedDateExpense(formattedDate);
    }
  };

  // Toggle calendar visibility when the button is clicked
  const handleButtonExpenseClick = () => {
    if (dateInputExpenseRef.current) {
      dateInputExpenseRef.current.click();
    }
  };

  const handleButtonSalesClick = () => {
    if (dateInputSalesRef.current) {
      dateInputSalesRef.current.click();
    }
  };

  return (
    <div className="w-screen h-screen ">
      <div className="w-full h-full overflow-hidden hidden sm:flex sm:flex-col">
        <SherDineNav
          sideNav={(state) => handleSideNav(state)}
          falseState={falseState}
        />
        <div className="w-full bg-[#f5f5f5] flex gap-3 h-full overflow-hidden">
          <div className="w-max h-full z-[9999]">
            <SideNav
              focus={"Dashboard"}
              state={sideNav}
              falseState={(state) => setFalseState(state)}
            />
          </div>
          <div className="w-full h-full flex pb-3 overflow-hidden">
            <div className="w-full flex flex-col pr-3 gap-3 overflow-x-hidden overflow-y-auto customScroll">
              <div className="w-full h-max flex pt-3 font-sans">
                <span className="w-full flex text-[1.25rem] font-semibold text-[#464255]">
                  Dashboard
                </span>
                {/* <div className="w-max flex justify-end items-start">
                  <div className="w-max flex gap-2 bg-[#fff] px-3 py-2 rounded-md shadow-[0px_0px_15px_rgba(0,0,0,0.1)] cursor-pointer">
                    <div className="flex justify-center items-center">
                      <img className="w-[2.5rem]" src={filter} alt="" />
                    </div>
                    <div className="w-max flex flex-col justify-center items-start text-[#3E4954]">
                      <span className="text-[.85rem]">Filter Period</span>
                      <span className="text-[.7rem] opacity-75">
                        17 April 2020 - 21 May 2020
                      </span>
                    </div>
                    <div className="flex justify-center items-center">
                      <img className="w-[1rem]" src={down} alt="" />
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="w-full h-full flex flex-col font-sans gap-3">
                <div className="w-full h-max grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                  <div className="bg-[#fff] flex flex-col p-3 rounded-md shadow-md gap-3">
                    <div className="w-full flex">
                      <div className="w-full flex flex-col gap-1 justify-center items-start text-left">
                        <span className="text-[1rem]">Total Sales</span>
                        <span className="text-[1.25rem] font-[600]">
                          {totals.totalBills}
                        </span>
                      </div>
                      <div className="w-max flex justify-center items-start">
                        <img className="w-[4rem]" src={totalsales} alt="?" />
                      </div>
                    </div>
                    <div className="w-full flex justify-start items-center text-[.9rem] gap-1">
                      <img className="w-[1rem] mt-[.1rem]" src={up} alt="" />
                      <span className="text-[#63B946]">{selectedDateSales ? "Selected" : "Today"}</span>
                    </div>
                  </div>
                  <div className="bg-[#fff] flex flex-col p-3 rounded-md shadow-md gap-3">
                    <div className="w-full flex">
                      <div className="w-full flex flex-col gap-1 justify-center items-start text-left">
                        <span className="text-[1rem]">Dine In</span>
                        <span className="text-[1.25rem] font-[600]">
                          {totals.dineInCount}
                        </span>
                      </div>
                      <div className="w-max flex justify-center items-start">
                        <img className="w-[4rem]" src={dinein} alt="?" />
                      </div>
                    </div>
                    <div className="w-full flex justify-start items-center text-[.9rem] gap-1">
                      <img className="w-[1rem] mt-[.1rem]" src={up} alt="" />
                      <span className="text-[#63B946]">{selectedDateSales ? "Selected" : "Today"}</span>
                    </div>
                  </div>
                  <div className="bg-[#fff] flex flex-col p-3 rounded-md shadow-md gap-3">
                    <div className="w-full flex">
                      <div className="w-full flex flex-col gap-1 justify-center items-start text-left">
                        <span className="text-[1rem]">Take Away</span>
                        <span className="text-[1.25rem] font-[600]">{totals.takeAwayCount}</span>
                      </div>
                      <div className="w-max flex justify-center items-start">
                        <img className="w-[4rem]" src={takeaway} alt="?" />
                      </div>
                    </div>
                    <div className="w-full flex justify-start items-center text-[.9rem] gap-1">
                      <img className="w-[1rem] mt-[.1rem]" src={up} alt="" />
                      <span className="text-[#63B946]">{selectedDateSales ? "Selected" : "Today"}</span>
                    </div>
                  </div>
                  <div className="bg-[#fff] flex flex-col p-3 rounded-md shadow-md gap-3">
                    <div className="w-full flex">
                      <div className="w-full flex flex-col gap-1 justify-center items-start text-left">
                        <span className="text-[1rem]">Delivery</span>
                        <span className="text-[1.25rem] font-[600]">{totals.deliveryCount}</span>
                      </div>
                      <div className="w-max flex justify-center items-start">
                        <img className="w-[4rem]" src={delivery} alt="?" />
                      </div>
                    </div>
                    <div className="w-full flex justify-start items-center text-[.9rem] gap-1">
                      <img className="w-[1rem] mt-[.1rem]" src={up} alt="" />
                      <span className="text-[#63B946]">{selectedDateSales ? "Selected" : "Today"}</span>
                    </div>
                  </div>
                </div>
                <div className="w-full rounded-md">
                  <SalesGraph />
                </div>

                <div className="w-full pb-1">
                  <div className="w-full flex gap-3">
                    <div className="w-1/2 flex flex-col p-3 bg-[#fff] rounded-md gap-3 shadow-[0px_0px_15px_rgba(0,0,0,0.1)]">
                      <div className="w-full flex text-nowrap">
                        <div className="w-full flex">
                          <span className="text-[#565656]">Total Sales</span>
                        </div>
                        <div className="w-full h-max flex justify-end items-start gap-2">
                          <div className="w-max h-[1.75rem] border px-2 py-1 rounded-[.313rem] flex justify-center items-center cursor-pointer">
                            <img
                              className="w-[1rem]"
                              src={Refresh}
                              alt="refresh"
                              onClick={() => {
                                setFormattedDateSales(formatDate(new Date()));
                                setSelectedDateSales(null);
                                fetchDashboardTotals(); // reset to today
                              }}
                            />
                          </div>
                          <div className="relative min-w-0 max-w-max h-max flex justify-end items-center">
                            <button
                              className="absolute flex justify-end items-center w-[6rem] h-[1.75rem] rounded-[.313rem] border p-1 text-[.8rem] gap-1"
                              onClick={handleButtonSalesClick}
                            >
                              <span className="">{formattedDateSales}</span>
                              <div className="fle justify-center items-center p-1">
                                <img className="w-[.75rem]" src={down} alt="" />
                              </div>
                            </button>
                            <div className="w-max flex">
                              <input
                                type="date"
                                ref={dateInputSalesRef}
                                selected={selectedDateSales}
                                onChange={handleDateChangeSales}
                                // onClickOutside={() => setShowDatePicker(false)}
                                // shouldCloseOnSelect={true} // Close the calendar once a date is selected
                                className="dateInput text-[.5rem] w-[6rem] h-[1.75rem] opacity-0 flex justify-center items-center"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {totals.total > 0 && (
                        <div className="w-full flex justify-center items-center text-[.9rem] font-semibold text-[#464255]">
                          <span>{selectedDateSales ? "Selected Revenue:" : "Today's Revenue:"}</span>
                          <span className="ml-1 text-[#0008B4]">₹ {totals.total.toFixed(2)}</span>
                        </div>
                      )}
                      {totals.total > 0 ? (
                        <div className="w-full flex flex-col gap-2 text-nowrap text-[.9rem]">
                          {totals.cashTotal > 0 && (
                            <div className="w-full flex justify-center items-center gap-2">
                              <span className="w-2/12 flex text-left">Cash</span>
                              <div className="w-8/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                                <div
                                  className="h-full bg-[#0008B4] rounded-full"
                                  style={{ width: `${(totals.cashTotal / totals.total) * 100}%` }}
                                ></div>
                              </div>
                              <span className="w-2/12 text-right">₹ {totals.cashTotal.toFixed(0)}</span>
                            </div>
                          )}
                          {totals.cardTotal > 0 && (
                            <div className="w-full flex justify-center items-center gap-2">
                              <span className="w-2/12 flex text-left">Card</span>
                              <div className="w-8/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                                <div
                                  className="h-full bg-[#57BEB5] rounded-full"
                                  style={{ width: `${(totals.cardTotal / totals.total) * 100}%` }}
                                ></div>
                              </div>
                              <span className="w-2/12 text-right">₹ {totals.cardTotal.toFixed(0)}</span>
                            </div>
                          )}
                          {totals.onlineTotal > 0 && (
                            <div className="w-full flex justify-center items-center gap-2">
                              <span className="w-2/12 flex text-left">Online</span>
                              <div className="w-8/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                                <div
                                  className="h-full bg-[#AE59DC] rounded-full"
                                  style={{ width: `${(totals.onlineTotal / totals.total) * 100}%` }}
                                ></div>
                              </div>
                              <span className="w-2/12 text-right">₹ {totals.onlineTotal.toFixed(0)}</span>
                            </div>
                          )}
                          {totals.dueTotal > 0 && (
                            <div className="w-full flex justify-center items-center gap-2">
                              <span className="w-2/12 flex text-left">Credit</span>
                              <div className="w-8/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                                <div
                                  className="h-full bg-[#c30000] rounded-full"
                                  style={{ width: `${(totals.dueTotal / totals.total) * 100}%` }}
                                ></div>
                              </div>
                              <span className="w-2/12 text-right">₹ {totals.dueTotal.toFixed(0)}</span>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="w-full h-full flex justify-center items-center text-[#999] text-[.9rem]">
                          No sales recorded today
                        </div>
                      )}
                    </div>
                    <div className="w-1/2 h-max flex flex-col p-3 bg-[#fff] rounded-md gap-3 shadow-[0px_0px_15px_rgba(0,0,0,0.1)]">
                      <div className="w-full flex justify-between items-center">
                        <span className="text-[#565656]">
                          {selectedDateSales ? "Selected Day's Summary" : "Today's Summary"}
                        </span>
                        <button
                          className="w-max h-[1.75rem] border px-2 py-1 rounded-[.313rem] flex justify-center items-center cursor-pointer"
                          onClick={() => fetchDashboardTotals(selectedDateSales)}
                          title="Refresh"
                        >
                          <img className="w-[1rem]" src={Refresh} alt="refresh" />
                        </button>
                      </div>
                      <div className="w-full grid grid-cols-2 gap-3 text-[.9rem]">
                        <div className="flex flex-col gap-1 bg-[#F8F8F9] rounded-md p-3">
                          <span className="text-[#7F7F7F]">Total Bills</span>
                          <span className="font-semibold text-[1.1rem] text-[#464255]">
                            {totals.totalBills}
                          </span>
                        </div>
                        <div className="flex flex-col gap-1 bg-[#F8F8F9] rounded-md p-3">
                          <span className="text-[#7F7F7F]">Net Revenue</span>
                          <span className="font-semibold text-[1.1rem] text-[#0008B4]">
                            ₹ {totals.total > 0 ? totals.total.toFixed(2) : "0.00"}
                          </span>
                        </div>
                        <div className="flex flex-col gap-1 bg-[#F8F8F9] rounded-md p-3">
                          <span className="text-[#7F7F7F]">Dine In</span>
                          <span className="font-semibold text-[1.1rem] text-[#464255]">
                            {totals.dineInCount}
                          </span>
                        </div>
                        <div className="flex flex-col gap-1 bg-[#F8F8F9] rounded-md p-3">
                          <span className="text-[#7F7F7F]">Take Away</span>
                          <span className="font-semibold text-[1.1rem] text-[#464255]">
                            {totals.takeAwayCount}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* .....................................mobile_VIew........................... */}

      <div className="w-full h-full flex flex-col sm:!hidden overflow-hidden">
        <div className="w-full h-max sticky top-0">
          <NavBarMobile title={"Dashboard"} />
        </div>
        <div
          className={`relative w-full h-full bg-[#f5f5f5] overflow-hidden ${
            sideNavState ? "" : ""
          }`}
          onClick={() => sideNavStateFunc(true)}
        >
          <div
            className={`h-full w-max absolute left-0 bg-[#f5f5f5] transition-transform duration-5000 ${
              sideNavState
                ? "translate-x-0 ease-out shadow-[5px_5px_100px_rgba(0,0,0,0.4)]"
                : "-translate-x-full ease-in duration-5000"
            }`}
          >
            <SideNavMob
              focus={"Dashboard"}
              state={sideNav}
              falseState={(state) => setFalseState(state)}
            />
          </div>
          <div className="w-full h-full flex flex-col gap-3 font-nunito overflow-auto noScroll bg-[#f5f5f5] p-3">
            <div className="w-full h-max grid grid-cols-1 md_mob:grid-cols-2 gap-3">
              <div className="bg-[#fff] flex p-3 rounded-[.313rem] shadow-md gap-3">
                <div className="w-full flex flex-col justify-center items-start text-left">
                  <span className="text-[1rem]">Total Sales</span>
                  <span className="NumSpan">350</span>
                </div>
              </div>
              <div className="bg-[#fff] flex p-3 rounded-[.313rem] shadow-md gap-3">
                <div className="w-full flex flex-col justify-center items-start text-left">
                  <span className="text-[1rem]">Dine In</span>
                  <span className="NumSpan">3504</span>
                </div>
              </div>
              <div className="bg-[#fff] flex p-3 rounded-[.313rem] shadow-md gap-3">
                <div className="w-full flex flex-col justify-center items-start text-left">
                  <span className="text-[1rem]">Take Away</span>
                  <span className="NumSpan">35</span>
                </div>
              </div>
              <div className="bg-[#fff] flex p-3 rounded-[.313rem] shadow-md gap-3">
                <div className="w-full flex flex-col justify-center items-start text-left">
                  <span className="text-[1rem]">Delivery</span>
                  <span className="NumSpan">122</span>
                </div>
              </div>
            </div>
            <div className="w-full h-max bg-[#fff] flex flex-col gap-3 px-3 pt-3 pb-2 rounded-md">
              <span className="text-[#565656]">Statistics</span>
              <div className="z-[1111]">
                <StatisticsGraph />
              </div>
            </div>
            <div className="w-full h-max flex rounded-md bg-[#fff] px-3 py-2">
              <div className="w-full flex gap-3">
                <div className="">Online Orders</div>
                <div className="">Online Payment</div>
              </div>
              <div className="w-max flex justify-center items-center">a</div>
            </div>
            <div className="w-full h-max grid grid-cols-1 md_mob:grid-cols-2 gap-3">
              <div className="bg-[#fff] flex p-3 rounded-[.313rem] shadow-md gap-3">
                <div className="w-full flex flex-col justify-center items-start text-left">
                  <span className="text-[1rem]">No of Orders</span>
                  <span className="NumSpan">35</span>
                </div>
              </div>
              <div className="bg-[#fff] flex p-3 rounded-[.313rem] shadow-md gap-3">
                <div className="w-full flex flex-col justify-center items-start text-left">
                  <span className="text-[1rem]">Total Sales</span>
                  <span className="NumSpan">35</span>
                </div>
              </div>
              <div className="bg-[#fff] flex p-3 rounded-[.313rem] shadow-md gap-3">
                <div className="w-full flex flex-col justify-center items-start text-left">
                  <span className="text-[1rem]">Zomato</span>
                  <span className="NumSpan">35</span>
                </div>
              </div>
              <div className="bg-[#fff] flex p-3 rounded-[.313rem] shadow-md gap-3">
                <div className="w-full flex flex-col justify-center items-start text-left">
                  <span className="text-[1rem]">Swiggy</span>
                  <span className="NumSpan">35</span>
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col p-3 bg-[#fff] rounded-md gap-3">
              <div className="w-full flex text-nowrap">
                <div className="w-full flex">
                  <span className="text-[#565656]">Total Sales</span>
                </div>
                <div className="w-full h-max flex justify-end items-start gap-2">
                  <div className="w-max h-[1.75rem] border px-2 py-1 rounded-[.313rem] flex justify-center items-center">
                    <img
                      className="w-[1rem]"
                      src={Refresh}
                      alt="<>"
                      onClick={() =>
                        setFormattedDateSales(formatDate(new Date()))
                      }
                    />
                  </div>
                  <div className="relative min-w-0 max-w-max h-max flex justify-end items-center">
                    <button
                      className="absolute flex justify-end items-center w-[6rem] h-[1.75rem] rounded-[.313rem] border p-1 text-[.8rem] gap-1"
                      onClick={handleButtonSalesClick}
                    >
                      <span className="mt-[.1rem]">{formattedDateSales}</span>
                      <div className="fle justify-center items-center p-1">
                        <img className="w-[.75rem]" src={down} alt="" />
                      </div>
                    </button>
                    <div className="w-max flex">
                      <input
                        type="date"
                        ref={dateInputSalesRef}
                        selected={selectedDateSales}
                        onChange={handleDateChangeSales}
                        // onClickOutside={() => setShowDatePicker(false)}
                        // shouldCloseOnSelect={true} // Close the calendar once a date is selected
                        className="text-[.5rem] w-[6rem] h-[1.75rem] opacity-0 flex justify-center items-center"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex justify-center items-center">
                <span className="w-max">Total Sales :</span>
                <span className="w-max font-[600]">&nbsp;₹ {totals.total}</span>
              </div>
              <div className="w-full flex flex-col gap-2 text-nowrap text-[.9rem]">
                {totals.cashTotal > 0 && (
                  <div className="w-full flex justify-center items-center gap-2">
                    <span className="w-3/12 flex text-left">Cash</span>
                    <div className="w-6/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                      <div
                        className="h-full bg-[#0008B4] rounded-full"
                        style={{ width: `${cashPercentage}%` }}
                      ></div>
                    </div>
                    <span className="w-3/12 text-right">
                      ₹ {totals.cashTotal}
                    </span>
                  </div>
                )}
                {totals.cardTotal > 0 && (
                  <div className="w-full flex justify-center items-center gap-2">
                    <span className="w-3/12 flex text-left">Card</span>
                    <div className="w-6/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                      <div
                        className="h-full bg-[#0008B4] rounded-full"
                        style={{ width: `${cardPercentage}%` }}
                      ></div>
                    </div>
                    <span className="w-3/12 text-right">
                      ₹ {totals.cardTotal}
                    </span>
                  </div>
                )}
                {totals.dueTotal > 0 && (
                  <div className="w-full flex justify-center items-center gap-2">
                    <span className="w-3/12 flex text-left">Due</span>
                    <div className="w-6/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                      <div
                        className="h-full bg-[#0008B4] rounded-full"
                        style={{ width: `${duePercentage}%` }}
                      ></div>
                    </div>
                    <span className="w-3/12 text-right">
                      ₹ {totals.dueTotal}
                    </span>
                  </div>
                )}
                {totals.otherTotal > 0 && (
                  <div className="w-full flex justify-center items-center gap-2">
                    <span className="w-3/12 flex text-left">Other</span>
                    <div className="w-6/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                      <div
                        className="h-full bg-[#0008B4] rounded-full"
                        style={{ width: `${otherPercentage}%` }}
                      ></div>
                    </div>
                    <span className="w-3/12 text-right">
                      ₹ {totals.otherTotal}
                    </span>
                  </div>
                )}
                {totals.onlinePayTotal > 0 && (
                  <div className="w-full flex justify-center items-center gap-2">
                    <span className="w-3/12 flex text-left">Online Pay</span>
                    <div className="w-6/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                      <div
                        className="h-full bg-[#0008B4] rounded-full"
                        style={{ width: `${onlinePayPercentage}%` }}
                      ></div>
                    </div>
                    <span className="w-3/12 text-right">
                      ₹ {totals.onlinePayTotal}
                    </span>
                  </div>
                )}
                {totals.onlineCODTotal > 0 && (
                  <div className="w-full flex justify-center items-center gap-2">
                    <span className="w-3/12 flex text-left">Online COD</span>
                    <div className="w-6/12 h-[0.6rem] rounded-full bg-[#E2E2E2]">
                      <div
                        className="h-full bg-[#0008B4] rounded-full"
                        style={{ width: `${onlineCODPercentage}%` }}
                      ></div>
                    </div>
                    <span className="w-3/12 text-right">
                      ₹ {totals.onlineCODTotal}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="w-full h-max flex flex-col px-3 pt-3 pb-2 bg-[#fff] rounded-md">
              <div className="w-full h-max flex text-nowrap">
                <div className="w-max flex">
                  <span className="text-[#565656]">Expenses</span>
                </div>
                <div className="w-full h-max flex justify-end items-start gap-2">
                  <div className="w-max h-[1.75rem] border px-2 py-1 rounded-[.313rem] flex justify-center items-center">
                    <img
                      className="w-[1rem]"
                      src={Refresh}
                      alt="<>"
                      onClick={() =>
                        setFormattedDateExpense(formatDate(new Date()))
                      }
                    />
                  </div>
                  <div className="relative min-w-0 max-w-max h-max flex justify-end items-center">
                    <button
                      className="absolute flex justify-end items-center w-[6rem] h-[1.75rem] rounded-[.313rem] border p-1 text-[.8rem] gap-1"
                      onClick={handleButtonExpenseClick}
                    >
                      <span className="mt-[.1rem]">{formattedDateExpense}</span>
                      <div className="fle justify-center items-center p-1">
                        <img className="w-[.75rem]" src={down} alt="" />
                      </div>
                    </button>
                    <div className="w-max flex">
                      <input
                        type="date"
                        ref={dateInputExpenseRef}
                        selected={selectedDateExpense}
                        onChange={handleDateChangeExpense}
                        // onClickOutside={() => setShowDatePicker(false)}
                        // shouldCloseOnSelect={true} // Close the calendar once a date is selected
                        className="text-[.5rem] w-[6rem] h-[1.75rem] opacity-0 flex justify-center items-center"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative w-full h-max flex justify-center items-center z-[111]">
                <Doughnut data={DonutData} options={options} />
                <div className="absolute transform -translate-y-1/4 flex flex-col gap-2 justify-center items-center">
                  <span>Total Expenses :</span>
                  <span className="font-[600] text-[1.25rem]">₹ 1000</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewDashboard;
